import { useDispatch, useSelector } from 'react-redux';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';
import { showSnackbar } from '../../../api/snackbarSlice';
import { apiClient } from '../../../utils/axios';

export const createBulkPDF = async (data) => {
  const reportData = {
    type: 'BULK_PDF_DOWNLOAD',
    filters: {
      start_date: data.startDate,
      end_date: data.endDate,
    },
  };
  await apiClient.post('/jobs', reportData);
};
export const useCreateBulkPDFHandler = () => {
  const dispatch = useDispatch();
  const { org } = useSelector((state) => state.org);
  const userEmail = org?.user?.email || '';
  const [error, setError] = useState(null);
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: createBulkPDF,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['bulkPDF'] });
      dispatch(
        showSnackbar({
          open: true,
          message: `Bulk pdf download initiated successfully. We will notify ${userEmail} once it is ready.`,
        }),
      );
    },
    onError: (err) => {
      setError(error.response.data.errors);
      dispatch(
        showSnackbar({
          open: true,
          message: `Failed to generate bulk pdfs: ${err.message}`,
          severity: 'error',
        }),
      );
    },
  });
  const onSubmit = async (data) => {
    mutation.mutate(data);
  };

  return {
    data: mutation.data,
    isError: mutation.isError,
    error: error,
    isPending: mutation.isPending,
    isSuccess: mutation.isSuccess,
    onSubmit: onSubmit,
  };
};
